module.exports = __webpack_public_path__ + "img/icon-add.7d2e6ba3.svg";